import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPodDataByContactId } from 'services/pod';
import { IPodData } from 'services/pod/types';
import { convertSimplifiedToPodData } from 'store/pod/helpers';

interface IProps {
  psaId: number;
  contactId: string;
}

export const ThunkGetCommonPodDataByContactId = createAsyncThunk<IPodData, IProps>(
  'pod/getCommonPodDataByContactId',
  async ({ psaId, contactId }) => getPodDataByContactId(psaId, contactId).then(r => r.data).then(data => convertSimplifiedToPodData(data)),
);
